// extracted by mini-css-extract-plugin
export default {"forgot_password":"ForgotPassword_forgot_password__+o5Zo","heading":"ForgotPassword_heading__0HZgm","form":"ForgotPassword_form__aTdFw","field":"ForgotPassword_field__qmJuQ"};